import { html } from "lit";
var icon_audience_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 32">
    <path
      d="M12.5 19a6 6 0 015.996 5.775L18.5 25v3h-2v-3a4 4 0 00-3.8-3.995L12.5 21h-4a4 4 0 00-3.995 3.8L4.5 25v3h-2v-3a6 6 0 015.775-5.996L8.5 19h4zm12-5a6 6 0 015.996 5.775L30.5 20v4h-2v-4a4 4 0 00-3.8-3.995L24.5 16h-4a3.999 3.999 0 00-3.623 2.303 7.966 7.966 0 00-1.797-.878 5.999 5.999 0 015.195-3.42L20.5 14h4zm-14-7a5 5 0 11-.001 10.001A5 5 0 0110.5 7zm0 2a3 3 0 100 6 3 3 0 000-6zm12-7a5 5 0 11-.001 10.001A5 5 0 0122.5 2zm0 2a3 3 0 100 6 3 3 0 000-6z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_audience_default as default
};
//# sourceMappingURL=icon-audience.js.map
